import DeviceNumberPicker from 'components/DeviceNumber';
import styled from 'styled-components';
import storage from 'utils/sessionStorage';
import AlarmClockUI from './AlarmClockUI';
import Logo from './Logo';

const Ontiloo = () => {
  const handleChooseDevice = async () => {
    const deviceNum = await DeviceNumberPicker.open();
    if (!deviceNum) return;
    storage.deviceCode.set(deviceNum.toString());
    location.reload();
  };
  return (
    <Container>
      <Logo />
      <div className="divider" />
      <AlarmClockUI />
      <StationNumber onClick={handleChooseDevice} type='button'><span>Device: {storage.deviceCode.get() || '0'}</span></StationNumber>
    </Container>
  );
};

export default Ontiloo;
const Container = styled.div`
  display: flex;
  align-items: center;
  .divider {
    background: #FFEFEB;
    width: 1px;
    height: 40px;
    margin: 0 24px;
  }
`;

const StationNumber = styled.button`
  margin-left: 16px;
  background: #fff;
  padding: 2px 8px;
  border-radius: 8px;
  span {
    color: #000;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  &:active {
    opacity: 0.6;
  }
`;
